import { useCallback } from 'react'

import { useAppDispatch, useAppSelector } from '../../../hooks/storeHooks'
import { selectSidebarIsOpen, setSidebarOpen, toggleSidebar, closeSidebar, openSidebar } from '../slices/sidebarSlice'

export const useSidebar = () => {
  const dispatch = useAppDispatch()
  const isOpen = useAppSelector(selectSidebarIsOpen)

  const setIsOpen = useCallback(
    (open: boolean) => {
      dispatch(setSidebarOpen(open))
    },
    [dispatch]
  )

  const toggle = useCallback(() => {
    dispatch(toggleSidebar())
  }, [dispatch])

  const close = useCallback(() => {
    dispatch(closeSidebar())
  }, [dispatch])

  const open = useCallback(() => {
    dispatch(openSidebar())
  }, [dispatch])

  return {
    isOpen,
    setIsOpen,
    toggle,
    close,
    open,
  }
}
